import Alpine from 'alpinejs';
import { decode } from 'html-entities';

Alpine.magic('decode', () => (value) => decode(value))
